import { render, staticRenderFns } from "./add-saleschannel-info-modal.vue?vue&type=template&id=7327f84c&"
import script from "./add-saleschannel-info-modal.vue?vue&type=script&lang=js&"
export * from "./add-saleschannel-info-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports